<template>
  <van-cell :title="$t('运动历史')" icon="bar-chart-o" is-link @click="open" />
</template>
<script>
import {Cell, Toast} from 'vant'
import {getCurrentDeviceImei} from '@/util/jsinterfaces-util'
import {getImei} from '@/util/session-storage-utils'
export default {
  components: {[Cell.name]: Cell},
  props: {device: {type: Object, default: () => ({})}},
  methods: {
    open() {
      const go = imei => {
        if (!imei) { Toast(this.$t('请先选择设备')); return }
        this.$router.push({name: 'device/activity', query: {_imei: imei}})
      }
      const imei = this.device.imei || this.$route.query._imei
      if (imei) go(imei)
      else if (window.app || window.WebViewJavascriptBridge) getCurrentDeviceImei(go)
      else go(getImei())
    }
  }
}
</script>
